/*
 * nn-cart-upsell.js
 * カート追加の通知（cart-notification）の一番下に「あなたへのおすすめ」を出す。
 *
 * - Dawn の assets/cart-notification.js は編集せず、要素の定義後に renderContents を包む
 * - 通知を開くたびにおすすめ欄を空にして作り直す（前回の結果を残さない）
 * - おすすめの中身は sections/nn-cart-upsell.liquid を Section Rendering で描画したもの
 * - 取得に失敗しても通知の他の部分は壊さない（おすすめ欄を出さないだけ）
 * - 通知が画面より長くなったとき、通知の中だけを縦にスクロールできるようにする
 *
 * 施策: NNNAIL No.15 同時購入のおすすめ（2026-10-16 指示書）
 */
(function () {
  if (window.nnCartUpsellLoaded) return;
  window.nnCartUpsellLoaded = true;

  var SECTION = 'nn-cart-upsell';
  var SLOT_ID = 'nn-cart-upsell';
  var requestSeq = 0;

  function recommendationsUrl(productId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (
      root +
      'recommendations/products?section_id=' +
      SECTION +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=10&intent=related'
    );
  }

  function addedProductId(parsedState) {
    if (!parsedState) return null;
    if (parsedState.product_id) return parsedState.product_id;
    if (parsedState.items && parsedState.items.length && parsedState.items[0].product_id) {
      return parsedState.items[0].product_id;
    }
    return null;
  }

  function ensureSlot(notification) {
    var slot = document.getElementById(SLOT_ID);
    if (slot) return slot;
    var links = notification.querySelector('.cart-notification__links');
    if (!links) return null;
    slot = document.createElement('div');
    slot.id = SLOT_ID;
    slot.className = 'nn-upsell';
    slot.hidden = true;
    links.insertAdjacentElement('afterend', slot);
    return slot;
  }

  // 通知の上端から画面の下端までを上限の高さにする（はみ出した分は通知の中でスクロール）
  function fitHeight(notification) {
    if (!notification) return;
    var wrapper = notification.parentElement;
    var top = wrapper ? wrapper.getBoundingClientRect().top : 0;
    var max = Math.max(window.innerHeight - Math.max(top, 0), 200);
    notification.style.setProperty('--nn-cart-notification-max-height', max + 'px');
    notification.classList.add('nn-cart-notification--scrollable');
  }

  function render(element, parsedState) {
    var notification = element.notification || document.getElementById('cart-notification');
    if (!notification) return;
    var slot = ensureSlot(notification);
    if (!slot) return;

    slot.hidden = true;
    slot.innerHTML = '';
    fitHeight(notification);

    var productId = addedProductId(parsedState);
    if (!productId) return;

    var seq = ++requestSeq;
    fetch(recommendationsUrl(productId))
      .then(function (response) {
        if (!response.ok) throw new Error('recommendations ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (seq !== requestSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.nn-upsell__inner');
        if (!inner) return;
        slot.innerHTML = '';
        slot.appendChild(inner);
        slot.hidden = false;
        fitHeight(notification);
      })
      .catch(function (error) {
        if (seq !== requestSeq) return;
        slot.hidden = true;
        slot.innerHTML = '';
        console.warn('[nn-cart-upsell]', error);
      });
  }

  function patch(CartNotification) {
    var proto = CartNotification.prototype;
    if (proto.nnUpsellPatched) return;
    proto.nnUpsellPatched = true;

    var originalRender = proto.renderContents;
    proto.renderContents = function (parsedState) {
      originalRender.call(this, parsedState);
      try {
        render(this, parsedState);
      } catch (error) {
        console.warn('[nn-cart-upsell]', error);
      }
    };

    window.addEventListener('resize', function () {
      var notification = document.getElementById('cart-notification');
      if (notification && notification.classList.contains('active')) fitHeight(notification);
    });
  }

  if (!window.customElements) return;
  customElements.whenDefined('cart-notification').then(function () {
    var CartNotification = customElements.get('cart-notification');
    if (CartNotification) patch(CartNotification);
  });
})();
